export { default } from './CookieControl';
